module.exports = __webpack_public_path__ + "static/media/1footer_logo.06776ac3.svg";